import axios from "axios";
import { SERVER_URL } from "../../../config/env";
import authHeader from "../../../2_ksbHub/utils/auth/auth-header";

class SommerService {
  async getSchoolyears() {
    const res = await axios.get(SERVER_URL + "eventmanager/schoolyears", {
      headers: authHeader(),
    });
    return res.data;
  }

  async getEvents(schoolyearId) {
    const res = await axios.get(
      SERVER_URL + `eventmanager/events/${schoolyearId}`,
      {
        headers: authHeader(),
      },
    );
    return res.data;
  }

  // ✅ EVENT
  async createEvent(data) {
    const res = await axios.post(
      SERVER_URL + "eventmanager/events/create",
      data,
      {
        headers: authHeader(),
      },
    );
    return res.data;
  }

  async getEvent(eventId) {
    const res = await axios.get(SERVER_URL + `eventmanager/${eventId}`, {
      headers: authHeader(),
    });
    return res.data;
  }

  async updateEvent(id, data) {
    const res = await axios.put(SERVER_URL + "eventmanager/event/" + id, data, {
      headers: authHeader(),
    });

    return res.data;
  }

  async deleteEvent(id) {
    const res = await axios.delete(SERVER_URL + "eventmanager/event/" + id, {
      headers: authHeader(),
    });
    return res.data;
  }

  // ✅ GET all data
  async getSommerData(eventId) {
    const res = await axios.get(SERVER_URL + `eventmanager/${eventId}`, {
      headers: authHeader(),
    });
    return res.data;
  }

  // ✅ SHIFT
  async createShift(data) {
    const res = await axios.post(
      SERVER_URL + "eventmanager/shift/create",
      data,
      {
        headers: authHeader(),
      },
    );
    return res.data;
  }

  async deleteShift(id) {
    const res = await axios.delete(SERVER_URL + "eventmanager/shift/" + id, {
      headers: authHeader(),
    });
    return res.data;
  }

  async updateShift(id, data) {
    const res = await axios.put(SERVER_URL + "eventmanager/shift/" + id, data, {
      headers: authHeader(),
    });
    return res.data;
  }

  async getShift(id) {
    const res = await axios.get(SERVER_URL + `eventmanager/shift/${id}`, {
      headers: authHeader(),
    });
    return res.data;
  }

  // ✅ LOCK / UNLOCK SCHOOLYEAR
  async updateLock(eventId, data) {
    const res = await axios.put(
      SERVER_URL + "eventmanager/events/" + eventId + "/lock",
      data,
      {
        headers: authHeader(),
      },
    );
    // console.log(res.data);
    return res.data;
  }

  // ✅ JOB

  async getJob(id) {
    const res = await axios.get(SERVER_URL + `eventmanager/job/${id}`, {
      headers: authHeader(),
    });
    return res.data;
  }

  async createJob(data) {
    const res = await axios.post(SERVER_URL + "eventmanager/job/create", data, {
      headers: authHeader(),
    });
    return res.data;
  }

  async updateJob(id, data) {
    const res = await axios.put(SERVER_URL + "eventmanager/job/" + id, data, {
      headers: authHeader(),
    });
    return res.data;
  }

  async deleteJob(id) {
    const res = await axios.delete(SERVER_URL + "eventmanager/job/" + id, {
      headers: authHeader(),
    });
    return res.data;
  }

  // ✅ RESERVATION
  async reserveSlot(angebotId, userId, isAnEventManagerAdmin) {
    // console.log(
    //   "Service calls with:",
    //   angebotId,
    //   userId,
    //   isAnEventManagerAdmin,
    // );

    const res = await axios.post(
      SERVER_URL + "eventmanager/reserve",
      { angebotId, userId, isAnEventManagerAdmin },
      { headers: authHeader() },
    );
    // console.log("reservation: ", "angebotId: ", angebotId, " userId: ", userId, " and res: ", res.data)
    return res.data;
  }

  async createSchoolyear(label, templateId = null) {
    const res = await axios.post(
      SERVER_URL + "eventmanager/schoolyears",
      { label, templateId },
      {
        headers: authHeader(),
      },
    );

    return res.data;
  }

  async getTemplates() {
    const res = await axios.get(SERVER_URL + "eventmanager/templates", {
      headers: authHeader(),
    });
    return res.data;
  }
}

const eventService = new SommerService();
export default eventService;
